import React from 'react';
import { useState } from 'react';

import Modal from '../../../components/UI/Modal/Modal';
import MessageFull from './MessageFull';
import styles from './Messages.module.css';

const Message = (props) => {

  const [showFull, setShowFull] = useState( false );

  let body = ''
  if (props.message && props.message?.body) {
    body = props.message.body.replace(/[#*_`>~\[\]!|-]/g, '').split('.')[0].substr(0,80).concat('... (bitte hier klicken um die Nachricht zu öffnen)')
  }

  return <div className={styles.message}>
    <Modal
      show={showFull}
      className='full'
      modalClosed={ () => { setShowFull(false) } }>
      <MessageFull message={props.message} />
    </Modal>
    <div className={styles.from} onClick={ ()=>setShowFull(true) }>{props.message?.from !== 'FindMe2care' && props.message?.from ? `Von: ${props.message?.from}` : null}</div>
    <div className={styles.subject} onClick={ ()=>setShowFull(true) }>{props.message?.subject}</div>
    <div className={styles.body} onClick={ ()=>setShowFull(true) }>{body}</div>
  </div>
};

export default Message;

//
